import * as React from 'react';
import clsx from 'clsx';
import { IconError } from '../../internal/icons';
import { FormContext } from './context';
import ErrorList from './ErrorList';
import { formClasses } from './style';
import { Grid2 } from '../../Mui/Grid2';
export const FormItemInput = (props) => {
    const { wrapperCol, children, errors, extra, fieldId } = props;
    const formContext = React.useContext(FormContext);
    const mergedWrapperCol = wrapperCol ?? formContext.wrapperCol ?? {};
    const className = clsx(`${formClasses.control.root}`, mergedWrapperCol.className);
    // Pass to sub FormItem should not with col info
    const subFormContext = React.useMemo(() => ({ ...formContext }), [formContext]);
    delete subFormContext.labelCol;
    delete subFormContext.wrapperCol;
    const inputDom = (React.createElement("div", { className: `${formClasses.control.input}` },
        React.createElement("div", { className: `${formClasses.control.content}` }, children)));
    const errorListDom = errors.length ? (React.createElement("div", { className: `${formClasses.item.explainError}-container` },
        React.createElement(IconError, { className: `${formClasses.item.explainError}-icon` }),
        React.createElement(ErrorList, { errors: errors, className: `${formClasses.item.explain}-connected`, fieldId: fieldId }))) : null;
    const extraProps = {};
    if (fieldId) {
        extraProps.id = `${fieldId}_extra`;
    }
    const extraDom = extra ? (React.createElement("div", { ...extraProps, className: clsx(formClasses.item.extra, {
            [`${formClasses.item.extraWithExplain}`]: !!errorListDom,
        }) }, extra)) : null;
    return (React.createElement(FormContext.Provider, { value: subFormContext },
        React.createElement(Grid2, { ...mergedWrapperCol, className: className },
            inputDom,
            errorListDom,
            extraDom)));
};
